<template>
  <section class="w-100">
    <div
      :id="`tenancy-${index}`"
      v-b-toggle="`collapse-sub-tenancy-${index}`"
      class="pt-3 mb-0">
      <div class="row">
        <div class="col">
          <h5 class="cursor-pointer hover width-only-content">
            <span v-if="subTenant.contactIds.length === 0">
              n/a
            </span>
            <span v-else>
              {{ getSubTenantsName }}
            </span>
            <span>
              :
              <template v-if="subTenant.startingAt && subTenant.startingAt !== -1 && subTenant.startingAt !== '-1'">
                {{ subTenant.startingAt | objectToDate }}
              </template>
              <template v-else>
                n/a
              </template>
              -
              <template v-if="subTenant.endingAt && subTenant.endingAt !== -1 && subTenant.endingAt !== '-1'">
                {{ subTenant.endingAt | objectToDate }}
              </template>
              <template v-else>
                n/a
              </template>
            </span>
          </h5>
        </div>
      </div>
    </div>
    <b-collapse
      :id="`collapse-sub-tenancy-${index}`"
      :visible="expandByDefault">
      <div class="row">
        <div
          v-if="readOnly"
          class="col-sm-12 col-md-3">
          <label for="tenants">
            {{ $t('message.onBoarding.buildings.objects.tenancies.subTenant') }}
          </label>
          <div v-if="subTenant.contactIds.length > 0">
            <template
              v-for="contactId in subTenant.contactIds">
              <div
                v-if="getContact(contactId)"
                :key="contactId">
                <a
                  role="button"
                  class="cursor-pointer"
                  tabindex="0"
                  @click="redirectToDetailPage(contactId)"
                  @click.middle="redirectToDetailPageMiddle(contactId)">
                  {{ getContact(contactId).name }}
                </a>
              </div>
            </template>
          </div>
          <span
            v-else
            class="d-block">-</span>
        </div>
        <div
          v-else
          class="col-sm-12 col-md-3">
          <!-- <coozzy-contact-multiselect
            id="tenants"
            v-model="tenants"
            :options="availableTenants"
            :clear-on-select="true"
            :disabled="disabledField"
            label="label"
            track-by="label">
            {{ $t('message.onBoarding.buildings.objects.tenancies.subTenant') }}
          </coozzy-contact-multiselect> -->
          <label>{{ $t('message.onBoarding.buildings.objects.tenancies.subTenant') }}</label>
          <contact-search-select
            v-model="tenants"
            :filters="{ active: true, isEmployee: false, isOnlyInterestedParty: false }"
            :placeholder="''"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
            :taggable="false"
            :disabled="disabledField"
            track-by="id"
            label="name"
            :with-address="true" />
        </div>
        <div class="col-sm-12 col-md-3">
          <coozzy-form-input
            v-model="dates.startingAt"
            :is-read-only="readOnly"
            :filter="'formatDate'"
            type="date"
            :disabled="disabledField"
            :state="$v.startingAt.$dirty && $v.startingAt.$error ? false : null"
            :name="$t('message.onBoarding.buildings.objects.tenancies.startAt') + (readOnly ? '' : '*')"
            @blur="dateToObject()" />
        </div>
        <div class="col-sm-12 col-md-3">
          <coozzy-form-input
            v-model="dates.endingAt"
            :is-read-only="readOnly"
            :filter="'formatDate'"
            type="date"
            :disabled="disabledField"
            :state="$v.endingAt.$dirty && $v.endingAt.$error ? false : null"
            :name="$t('message.onBoarding.buildings.objects.tenancies.endAt')"
            @blur="dateToObject()" />
        </div>
        <div
          v-if="!readOnly"
          class="col-md-1">
          <label
            for="delete"
            class="text-white d-block">delete</label>
          <coozzy-button
            design="alert"
            class="align-self-center"
            @click="openConfirmationModal()">
            {{ $t('message.generic.delete') }}
          </coozzy-button>
        </div>
      </div>
    </b-collapse>
    <b-modal
      :id="'subtenant-confirmationModal'"
      ref="subtenant-confirmationModal"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.onBoarding.deleteModals.titleSubTenants')">
      <template>
        <div class="col">
          <p>{{ $t('message.onBoarding.deleteModals.bodySubTenants') }}</p>
        </div>
        <div class="col">
          <coozzy-button
            size="small"
            class="mb-0 border"
            design="transparent"
            @click="$bvModal.hide('subtenant-confirmationModal')">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            size="small"
            class="float-right mb-0"
            design="green"
            @click="deleteSubTenantClicked()">
            {{ $t('message.generic.delete') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
  </section>
</template>
<script>
import Vue from 'vue'
import { routeChecks } from '@/mixins/routeChecks'
import { onboarding } from '@/mixins/onboarding'
import { validation } from '@/mixins/validation'
import { dateUtils } from '@/mixins/dateUtils'
import ContactSearchSelect from '@/framework/components/search/ContactSearchSelect.vue'
import { required } from 'vuelidate/lib/validators'
import ContactApi from '@/misc/apis/ContactApi'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'

function lessThanEnding(value, vm) {
  if ((!value || new Date(this.$options.filters.objectToDateInput(value)).getTime() / 1000 <= 0)) {
    return true
  }
  if ((!vm.endingAt || new Date(this.$options.filters.objectToDateInput(vm.endingAt)).getTime() / 1000 <= 0)) {
    return true
  }

  return new Date(this.$options.filters.objectToDateInput(value)) <= new Date(this.$options.filters.objectToDateInput(vm.endingAt))
}
function lessThanTenancyEnding(value, vm) {
  if ((!value)) {
    return true
  }
  if (!vm.tenancy.endingAt) {
    return true
  }

  return new Date(this.$options.filters.objectToDateInput(value)) <= new Date(this.$options.filters.objectToDateInput(vm.tenancy.endingAt))
}
function moreThanStartingContract(value, vm) {
  if (!value) {
    return true
  }
  return new Date(this.$options.filters.objectToDateInput(value)) >= new Date(this.$options.filters.objectToDateInput(this.tenancy.startingAt))
}
function moreThanStarting(value, vm) {
  if (!value) {
    return true
  }
  if ((!vm.startingAt || new Date(this.$options.filters.objectToDateInput(vm.startingAt)).getTime() / 1000 <= 0)) {
    return true
  }
  return new Date(this.$options.filters.objectToDateInput(value)) >= new Date(this.$options.filters.objectToDateInput(vm.startingAt))
}
export default {
  name: 'TenancySubtenant',
  components: {
    CoozzyButton,
    CoozzyFormInput,
    ContactSearchSelect
  },
  mixins: [routeChecks, onboarding, validation, dateUtils],
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    expandByDefault: {
      type: Boolean,
      default: true
    },
    subTenant: {
      type: Object,
      default: null
    },
    tenancy: {
      type: Object,
      default: null
    },
    disabledField: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dates: {
        startingAt: null,
        endingAt: null
      },
      usedContacts: [],
      initialEndingAt: null
    }
  },
  computed: {
    getSubTenantsName() {
      let names = ''
      const array = this.subTenant.contactIds
      for (let index = 0; index < array.length; index++) {
        names = names + (index === 0 ? this.getContactName(array[index]).substr(2) : this.getContactName(array[index]))
      }
      return names
    },
    tenants: {
      get() {
        return this.subTenant.contactIds.map(tenantId => {
          return this.usedContacts.find(t => {
            return t.objectID === tenantId || t.id === tenantId
          })
        }).filter(t => {
          return t
        })
      },
      set(value) {
        const newSubTenant = this.subTenant
        newSubTenant.contactIds = value.map(v => v.objectID || v.id)
        this.usedContacts = this.usedContacts.concat(value)
        this.usedContacts = [...this.removeDuplicatesContact(this.usedContacts)]
        this.$emit('change-subtenant', newSubTenant)
      }
    },
    correspondenceContactOption: {
      get() {
        return this.usedContacts.find(t => {
          return t.objectID === this.subTenant.correspondenceContactId
        })
      },
      set(value) {
        const newSubTenant = this.subTenant
        if (value.length > 0) {
          newSubTenant.correspondenceContactId = value[value.length - 1].objectID
          this.usedContacts.push(value[value.length - 1])
          this.usedContacts = [...this.removeDuplicatesContact(this.usedContacts)]
        } else {
          newSubTenant.correspondenceContactId = null
        }
        this.$emit('change-subtenant', newSubTenant)
      }
    },
    startingAt: {
      get() {
        return this.subTenant.startingAt !== -1 ? this.subTenant.startingAt : null
      },
      set(value) {
        const newSubTenant = this.subTenant
        newSubTenant.startingAt = value
        this.$emit('change-subtenant', newSubTenant)
      }
    },
    endingAt: {
      get() {
        return this.subTenant.endingAt !== -1 && this.subTenant.endingAt !== '0' ? this.subTenant.endingAt : null
      },
      set(value) {
        const newSubTenant = this.subTenant
        newSubTenant.endingAt = value
        this.$emit('change-subtenant', newSubTenant)
      }
    }
  },
  watch: {
  'tenancy.endingAt': function (newVal) {
    if (!this.initialEndingAt) {
      this.dates.endingAt = this.$options.filters.objectToDateInput(newVal)
    }
  }
},
  mounted() {
    this.getDatesFromObjects()
    const contactsToLoadAlgolia = this.subTenant.contactIds
    if (this.subTenant.correspondenceContactId) {
      contactsToLoadAlgolia.push(this.subTenant.correspondenceContactId)
    }
    this.availableTenants(contactsToLoadAlgolia.filter(x => x !== null && x !== ''))
    this.initialEndingAt = this.subTenant.endingAt
  },
  methods: {
    dateToObject() {
      this.startingAt = this.toObject(this.dates.startingAt)
      this.endingAt = this.toObject(this.dates.endingAt)
    },
    openConfirmationModal() {
      this.$refs['subtenant-confirmationModal'].show()
    },
    getDatesFromObjects: function () {
      this.dates.startingAt = this.$options.filters.objectToDateInput(this.startingAt)
      this.dates.endingAt = this.$options.filters.objectToDateInput(this.endingAt)
    },
    getContactName(contactId) {
      const contact = this.getContact(contactId)
      return contact ? ', ' + contact.name : '-'
    },
    redirectToDetailPage(contactId) {
      if (contactId !== null) {
        if (this.isOwnerModule) {
          this.$router.push({
            name: 'OwnerContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAssetModule) {
          this.$router.push({
            name: 'AssetContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAccountingModule) {
          this.$router.push({
            name: 'AccountingContactDetailsView',
            params: { id: contactId }
          })
        } else {
          this.$router.push({
            name: 'AdminContactDetailsView',
            params: { id: contactId }
          })
        }
      }
    },
    redirectToDetailPageMiddle(contactId) {
      if (contactId !== null) {
        let route = ''
        if (this.isOwnerModule) {
          route = this.$router.resolve({
            name: 'OwnerContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAssetModule) {
          route = this.$router.resolve({
            name: 'AssetContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAccountingModule) {
          route = this.$router.resolve({
            name: 'AccountingContactDetailsView',
            params: { id: contactId }
          })
        } else {
          route = this.$router.resolve({
            name: 'AdminContactDetailsView',
            params: { id: contactId }
          })
        }
        window.open(route.href, '_blank')
      }
    },
    getContact(contactId) {
      return this.usedContacts.find(contact => contact.objectID === contactId || contact.id === contactId)
    },
    deleteSubTenantClicked() {
      this.$emit('delete-subtenant')
      this.$refs['subtenant-confirmationModal'].hide()
    },
    availableTenants(search) {
      ContactApi.contactResolve(search)
        .then(response => {
          const contacts = response.persons.concat(response.companies)
          this.usedContacts = this.usedContacts.concat(contacts)
        })
        .catch(e => {
          console.log(e)
        })
    },
    isInvalid() {
      let valid = true
      // check if the subtenant ending date is before the tenancy ending date
      // if not set the tenancy ending date to subtenant ending date
      if (this.tenancy.endingAt) {
        const subtenantEndDate = this.subTenant.endingAt ? new Date(this.$options.filters.objectToDateInput(this.subTenant.endingAt)) : null
        const tenantEndDate = new Date(this.$options.filters.objectToDateInput(this.tenancy.endingAt))
        if (!subtenantEndDate || (tenantEndDate.getTime() < subtenantEndDate.getTime())) {
          this.subTenant.endingAt = this.tenancy.endingAt
        }
      }
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.scrollToError()
          valid = false
        }
        if (this.$v.startingAt.$dirty && this.$v.startingAt.$error) {
          Vue.toasted.show(this.$t('message.savingErrors.subTenancyStartingAtAfterEndingAt'), {
            type: 'error',
            duration: 5000
          })
        }
        if (this.$v.endingAt.$dirty && this.$v.endingAt.$error && !this.$v.endingAt.moreThanStarting) {
          Vue.toasted.show(this.$t('message.savingErrors.subTenantStartingDate'), { type: 'error' })
        }
        if (this.$v.endingAt.$dirty && this.$v.endingAt.$error && !this.$v.endingAt.lessThanTenancyEnding) {
          Vue.toasted.show(this.$t('message.savingErrors.subTenantLessThenEnding'), { type: 'error' })
        }
        return !valid
    }
  },
  validations: {
    startingAt: {
      required,
      moreThanStartingContract,
      lessThanEnding
    },
    endingAt: {
      moreThanStarting,
      lessThanTenancyEnding
    }
  }
}
</script>
